import * as Card from './card';

export default Card.default;